import { useNotifications } from '@components/Notifications';
import { OBJECTIVES_FORM_MAX_FILE_SIZE } from '@mailings/components/creators/personalized-mailing-creator-wizard/validations/uploadFile.validations';
import {
  UploadStatus,
  FileRestrictionsErrors,
  FileRestrictions,
} from '@src/types/files-upload-types';
import { formatBytes } from '@src/utils/formatBytes';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useObjectivesFormFileUploadStatus = () => {
  const [uploadStatus, setUploadStatus] = useState<UploadStatus>('idle');
  const [fileUploadRestrictionsErrors, setFileUploadRestrictionsErrors] =
    useState<FileRestrictionsErrors<FileRestrictions> | null>(null);

  const { t } = useTranslation(['mailings']);
  const { showErrorNotification } = useNotifications();

  useEffect(() => {
    if (!fileUploadRestrictionsErrors) {
      return;
    }
    if (fileUploadRestrictionsErrors.allowedMimeTypes) {
      showErrorNotification(
        t('mailings:personalizedMailingCreatorWizard.objectivesForm.fileUpload.wrongType'),
      );
      return;
    }
    if (fileUploadRestrictionsErrors.maxFileSize) {
      showErrorNotification(
        t('mailings:personalizedMailingCreatorWizard.objectivesForm.fileUpload.maxSize', {
          maxSize: formatBytes(OBJECTIVES_FORM_MAX_FILE_SIZE),
        }),
      );
    }
  }, [fileUploadRestrictionsErrors, showErrorNotification, t]);

  return { uploadStatus, setUploadStatus, setFileUploadRestrictionsErrors };
};
